import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useApiData(route, filters) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const params = {
    policy_plan_id: filters.policyPlanId,
    team_id: filters.teamId,
    cycle_id: filters.cycleId,
  };

  useEffect(() => {
    if (route) {
      setLoading(true);

      axios
        .get(route, { params })
        .then((response) => {
          setData(response.data.data);
          setLoading(false);
        });
    }
  }, [route, filters.policyPlanId, filters.teamId, filters.cycleId]);

  return { data, loading };
}
